import { render, staticRenderFns } from "./Tag-Selector.vue?vue&type=template&id=ec06edc4&scoped=true&lang=pug"
import script from "./Tag-Selector.vue?vue&type=script&setup=true&lang=ts"
export * from "./Tag-Selector.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Tag-Selector.vue?vue&type=style&index=0&id=ec06edc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec06edc4",
  null
  
)

export default component.exports